/* Poster-first decorative media. No source URLs are assigned on mobile,
   reduced-motion or Save-Data connections. Shopping never depends on this. */
(() => {
  'use strict';
  if (window.OatesHeroMedia) {
    window.OatesHeroMedia.init(document);
    return;
  }
  const instances = new Map();
  function mount(video) {
    if (instances.has(video)) return;
    const poster = video.closest('.hero__media')?.querySelector('.hero__poster img');
    if (!poster) return;
    const desktop = matchMedia('(min-width: 769px)');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    let disposed = false, pending = false, loaded = false;
    let ready = false;
    const eligible = () => !disposed && video.isConnected && ready &&
      desktop.matches && !motion.matches && !connection?.saveData &&
      document.visibilityState === 'visible';
    function stop() {
      video.pause();
      video.removeAttribute('data-playing');
    }
    function play() {
      pending = false;
      if (!eligible()) return;
      if (!loaded) {
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
        });
        loaded = true;
        video.preload = 'auto';
        video.load();
      }
      const result = video.play();
      if (result?.catch) result.catch(stop);
    }
    function update() {
      if (!eligible()) {
        stop();
        return;
      }
      if (pending || !video.paused) return;
      pending = true;
      // The decoded poster gets two frames before decorative work is scheduled.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(play, { timeout: 2000 });
        } else {
          setTimeout(play, 200);
        }
      }));
    }
    async function afterLoad() {
      if (disposed) return;
      try {
        if (poster.decode) await poster.decode();
      } catch (_) {
        // If the poster fails, retain the section's CSS fallback.
        return;
      }
      if (!poster.complete || !poster.naturalWidth || disposed) return;
      ready = true;
      update();
    }
    function playing() {
      if (eligible()) video.setAttribute('data-playing', 'true');
      else stop();
    }
    video.addEventListener('playing', playing);
    video.addEventListener('error', stop);
    desktop.addEventListener('change', update);
    motion.addEventListener('change', update);
    connection?.addEventListener('change', update);
    document.addEventListener('visibilitychange', update);
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });
    instances.set(video, () => {
      disposed = true;
      stop();
      window.removeEventListener('load', afterLoad);
      video.removeEventListener('playing', playing);
      video.removeEventListener('error', stop);
      desktop.removeEventListener('change', update);
      motion.removeEventListener('change', update);
      connection?.removeEventListener('change', update);
      document.removeEventListener('visibilitychange', update);
      instances.delete(video);
    });
  }
  function init(root) {
    root.querySelectorAll('video[data-poster-first]').forEach(mount);
  }
  window.OatesHeroMedia = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, video) => {
      if (event.target.contains(video)) dispose();
    });
  });
})();
